import { render, staticRenderFns } from "./TestDialog.vue?vue&type=template&id=38eacf6b&"
import script from "./TestDialog.vue?vue&type=script&lang=js&"
export * from "./TestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports